import QWLogo from 'assets/images/poweredBy_logo.png'
import FirstPlaceBg from 'assets/images/first-place-bg.png'
import FirstPlaceIcon from 'assets/images/icon-first-place.svg'
import SecondPlaceIcon from 'assets/images/icon-second-place.svg'
import ThirdPlaceIcon from 'assets/images/icon-third-place.svg'

import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { v4 } from 'uuid';
import config from 'config';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Models
import IResult from 'models/Result';
// Types
import QuizTypes from 'types/QuizTypes';
// Async
import { getResult } from 'store/player/playerAsync';
// Selectors
import { selectResult } from 'store/player/playerSelectors';
// Components
import AppBar from 'pages/LiveLeaderboardPage/AppBar';
import ResultItem from './ResultItem';
import AppLoader from 'components/AppLoader';
import { QRCodeCanvas } from "qrcode.react";
// Utilities
import { buildUserName } from 'utilities/Utilities';

let interval: any;
const limit = 10;

const LiveLeaderboardPage:FC = () => {
  const { slug } = useParams<{ slug:string }>();
  const { groupSlug } = useParams<{ groupSlug:string }>();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [isLargeScreen, setIsLargeScreen] = useState(window.matchMedia("(min-width: 640px)").matches);

  const mediaHandler = (e:any) => setIsLargeScreen(e.matches);

  useEffect(() => {
    window.matchMedia("(min-width: 640px)").addEventListener('change', mediaHandler);

    return () => {
      window.matchMedia("(min-width: 640px)").removeEventListener('change', mediaHandler);
    }
  }, []);

  const result:any = useAppSelector(selectResult);
  const quiz:any = result?.quiz || null;
  const quizGroup:any = result?.quizGroup || null;
  const results:IResult[] = result?.results || [];
  const [loading, setLoading] = useState<boolean>(false);

  const fetchResult = (isTimer: boolean) => {
    if (groupSlug) {
      dispatch(getResult({ quizGroupName: groupSlug, limit })).unwrap()
        .catch(() => {
          if (!isTimer) {
            navigate('/404-not-found');
          }
        })
        .finally(() => setLoading(false));
    }
    if (slug) {
      dispatch(getResult({ quizName: slug, limit })).unwrap()
      .catch(() => {
        if (!isTimer) {
          navigate('/404-not-found');
        }
      })
      .finally(() => setLoading(false));
    }
  }

  useEffect(() => {
    setLoading(true);
    fetchResult(false);

    // interval = setInterval(() => { fetchResult(true) }, 10000);

    const rootDiv = document.getElementById('root');
    rootDiv?.classList.add('liveLeaderboardMode');

    return () => {
      clearInterval(interval);
      rootDiv?.classList.remove('liveLeaderboardMode');
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!quiz) return;
    if (quiz.type === QuizTypes.Prediction && quiz.numberOfQuestions === quiz.numberOfAnsweredQuestions) {
      clearInterval(interval);
    }
  }, [quiz]);

  const qrCodeLink = quiz?.publicLeaderboard.quizQRCodeLink || `${config.quizURL}/quiz/${quiz?.quizNameSlug}`;
  const bgImageUrl = quiz ? quiz.publicLeaderboard.wallpaperImage : quizGroup ? quizGroup.publicLeaderboard.wallpaperImage : '';
  
  if (loading || !result) return <AppLoader />;
  return (
    <div
      className="h-full overflow-scroll px-4 py-2 bg-cover bg-center bg-black sm:px-8 sm:py-4 xl:bg-right-top"
      style={{ backgroundImage: `url(${bgImageUrl})` }}
    >
      <AppBar isLargeScreen={isLargeScreen} />
      <div className="relative z-40 flex flex-col sm:gap-12 xl:flex-row xl:justify-between xl:gap-8" style={{ fontFamily: 'Gotham' }}>
        <div className="w-full xl:w-3/6">
          <div
            className="
              relative overflow-hidden
              w-full px-4 py-8
              flex items-center gap-2
              border-2 rounded-3xl
              sm:px-8 sm:py-16 sm:gap-12
            "
            style={{ borderColor: 'rgba(255,255,255,0.6)' }}
          >
            <div
              className="absolute top-0 left-0 h-full w-full"
              style={{ background: `linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${FirstPlaceBg}) left / contain no-repeat`, zIndex: -1 }}
            />
            <img src={FirstPlaceIcon} className="h-20 sm:h-48" alt="first-place-logo" />
            <div className="translate-y-2 sm:translate-y-6">
              <h3 className="text-lg font-bold sm:text-6xl" style={{ color: '#F9CA01' }}>1ST PLACE</h3>
              {!!results[0] && (
                <>
                  <h2 className="text-lg font-bold text-white uppercase sm:py-2 sm:text-6xl">{buildUserName(results[0])}</h2>
                  <h4 className="text-lg font-bold sm:text-6xl" style={{ color: '#F1D971' }}>{`${results[0]?.score} Pts`}</h4>
                </>
              )}
            </div>
          </div>
          <div className="w-full flex justify-between mt-4 xl:mt-24">
            <div className="w-3/6 p-2 border-x py-12" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>
              <img src={SecondPlaceIcon} className="h-12 mx-auto mt-4 mb-12 sm:h-32" alt="second-place-logo" />
              <h3 className="text-lg font-bold text-white text-center mb-4 sm:text-5xl">2ND</h3>
              {!!results[1] && (
                <>
                  <h2 className="text-sm font-bold text-white text-center uppercase sm:text-4xl">{buildUserName(results[1])}</h2>
                  <h4 className="text-sm font-bold text-white text-center sm:text-4xl">{`${results[1]?.score} Pts`}</h4>
                </>
              )}
            </div>
            <div className="w-3/6 p-2 border-r py-12" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>
              <img src={ThirdPlaceIcon} className="h-12 mx-auto mt-4 mb-12 sm:h-32" alt="third-place-logo" />
              <h3 className="text-lg font-bold text-white text-center mb-4 sm:text-5xl">3RD</h3>
              {!!results[2] && (
                <>
                  <h2 className="text-sm font-bold text-white text-center uppercase sm:text-4xl">{buildUserName(results[2])}</h2>
                  <h4 className="text-sm font-bold text-white text-center sm:text-4xl">{`${results[2]?.score} Pts`}</h4>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col xl:w-3/6">
          <div className="order-1 xl:order-none" style={{
              width: isLargeScreen ? quiz?.publicLeaderboard.quizQRCodeTitle ? 280 : 328 : 140,
              height: isLargeScreen ? 328 : 'auto',
            }}
          >
            {quiz && quiz.publicLeaderboard.quizQRCodeEnabled && (
              <div className="p-2 bg-white rounded-xl w-full h-full sm:mt-8 xl:mt-0">
                <h2 className="text-xs font-bold text-center mb-2 text-wrap sm:text-xl">{quiz?.publicLeaderboard.quizQRCodeTitle}</h2>
                <QRCodeCanvas
                  value={qrCodeLink}
                  level="H"
                  size={isLargeScreen ? quiz?.publicLeaderboard.quizQRCodeTitle ? 264 : 302 : 124}
                  imageSettings={{
                    src: !quiz?.whiteLabeling ? QWLogo : '',
                    width: isLargeScreen ? 120: 50,
                    height: isLargeScreen ? 47: 20,
                    excavate: true
                  }}
                />
              </div>
            )}
          </div>
          {/* <div className="w-full h-64 mt-4 overflow-scroll xl:h-auto"> */}
          <div className="w-full mt-4 xl:mt-24">
            {results?.slice(3, 10).map((result) => (
              <ResultItem key={v4()} result={result} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveLeaderboardPage;
